<template>
  <div>
    <v-form lazy-validation>
      <h5>Add new schedule</h5>
      <v-row>
        <v-col cols="12" lg="12">
          <v-text-field v-model="eventTitle" label="Event Title"/>
        </v-col>
        <v-col cols="12" lg="12">
          <v-textarea :auto-grow="true" rows="1" v-model="eventDescription" label="Event Description">
          </v-textarea>
        </v-col>
        <v-col cols="12" lg="3">
          <v-select
            width="200px"
            v-model="selectedDow"
            outlined
            :items="dayOfWeeks"
            label="Day of Week"
          ></v-select>
        </v-col>
        <v-col cols="12" lg="3">
          <v-menu
            ref="menu"
            v-model="startTimeMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="startTime24"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field readonly :value="startTime" label="Start Time" prepend-icon="mdi-calendar-clock" v-on="on"></v-text-field>
            </template>
            <v-time-picker
              v-if="startTimeMenu"
              v-model="startTime24"
              full-width
              @click:minute="$refs.menu.save(startTime24)"
            ></v-time-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" lg="3">
          <v-menu
            ref="menu2"
            v-model="endTimeMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="endTime24"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                readonly
                :rules="timeRules"
                :value="endTime"
                label="End Time"
                prepend-icon="mdi-calendar-clock"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="endTimeMenu"
              v-model="endTime24"
              full-width
              @click:minute="$refs.menu2.save(endTime24)"
            ></v-time-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" lg="3" align="right">
          <v-btn @click="addSchedule" :disabled="isAppLoading">Add</v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-divider />

    <div v-if="events != null && events.length > 0">
      <h5>Existing Schedules</h5>
      <v-list dense>
        <v-list-item v-for="( event ) in events" :key="event.start.dateTime.value">
          <v-list-item-content>
            <div v-if="event.recurrence && event.recurrence.length > 0">
              <h5> 
                {{event.summary}}
                <small>{{formatDate(event.start.dateTime, 'date')}} to {{parseRRuleEndDate(event)}},
                Every {{formatDate(event.start.dateTime, 'dow')}} {{formatDate(event.start.dateTime, 'time')}} - {{formatDate(event.end.dateTime, 'time')}}
                </small>
              </h5>
              {{event.description}}
                <div class="ml-5" v-for="(d) in parseRRuleFromEvent(event)" :key="d.toString()">
                    <br/>{{d}}
                </div>
            </div>
            <span
              v-else
            >{{formatDate(event.start.dateTime, false)}} - {{formatDate(event.end.dateTime, true)}}</span>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn @click="deleteEvent(event)" :disabled="isAppLoading" icon>
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </div>
    <div v-else>
      <h4>No existing schedule found for this course</h4>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { rrulestr } from 'rrule'


export default {
  props: ["events", "calendar", "dates", "course"],
  data() {
    return {
      eventTitle: '',
      eventDescription: '',
      dayOfWeeks: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      selectedDow: "Monday",
      startTimeMenu: false,
      endTimeMenu: false,
      startTime24: "12:00",
      endTime24: "13:00",
      timeRules: [
        () =>
          this.compareTimeString(this.startTime24, this.endTime24) ||
          "End time must be after start time"
      ]
    };
  },
  computed: {
    ...mapGetters(["isAppLoading"]),
    startTime() {
      return moment(this.startTime24, "HH:mm").format("hh:mm a");
    },
    endTime() {
      return moment(this.endTime24, "HH:mm").format("hh:mm a");
    }
  },
  methods: {
    addSchedule() {
      const startDate = this.dates[0];
      const endDate = this.dates[1];

      if(startDate == null || endDate == null){
        this.$store.dispatch('addMessage', { message: 'Please choose the start and end date first', messageClass: 'warning'});
        return;
      }

      const startDateTime = moment(`${startDate}T${this.startTime24}`).format();
      const endDateTime = moment(`${endDate}T${this.endTime24}`).format();

      const newSchedule = {
        dow: this.selectedDow,
        start: this.startTime,
        end: this.endTime,
        calendar: this.calendar,
        startDateTime,
        endDateTime,
        title: this.eventTitle,
        description: this.eventDescription
      };

      this.$axios
        .post("/classroom/course/event", newSchedule)
        .then(resp => {
          const event = resp.data;
          this.events.push(event);
          this.$emit("update:events", this.events);
        })
        .then(
          this.syncCourse
        )
        .catch(err => {
          this.$store.dispatch("addMessage", {
            message: err.data,
            messageClass: "danger"
          });
        });
    },
    deleteEvent(event) {
      const params = { eventId: event.id, calendarId: this.calendar };
      this.$axios
        .post("/classroom/course/delete/event", null, { params })
        .then(resp => {
          const deletedId = resp.data;
          this.events.splice(
            this.events.findIndex(e => e.id == deletedId),
            1
          );
          this.$emit("update:events", this.events);
        })
        .then(
          this.syncCourse
        )
        .catch(err => {
          this.$store.dispatch("addMessage", {
            message: err.data,
            messageClass: "danger"
          });
        });
    },
    formatDate(dateTime, mode) {
      if (mode === 'time') {
        return new moment(dateTime.value).format("h:mm a");
      } 
      else if (mode === 'date time') {
        return new moment(dateTime.value).format("MMM DD, YYYY h:mm a");
      }
      else if (mode === 'date time with dow') {
        return new moment(dateTime.value).format("ddd MMM DD, YYYY h:mm a");
      }
      else if (mode === 'date') {
        return new moment(dateTime.value).format("MMM DD, YYYY");
      }
      else if (mode === 'date with dow') {
        return new moment(dateTime.value).format("ddd MMM DD, YYYY");
      }
      else if (mode === 'dow') {
        return new moment(dateTime.value).format("dddd");
      }
    },
    compareTimeString(time1, time2) {
      const startTime = moment(time1, "HH:mm");
      const endTime = moment(time2, "HH:mm");
      const isAfter = endTime.isAfter(startTime);
      return isAfter;
    },
    parseRRuleFromEvent(event){
        const dtStartUTC = moment(event.start.dateTime.value).utc();
        const dtStartRRuleFormat = dtStartUTC.format("YYYYMMDDTHHMMSS[Z]");
        if(event.recurrence && event.recurrence){
            const rrule = event.recurrence[0];
            const rule = rrulestr(`DTSTART:${dtStartRRuleFormat}\n${rrule}`);
            return rule.all(function (date, i){return i < 300});
        }
        return [];
    },
    parseRRuleEndDate(event){
        if(event.recurrence && event.recurrence){
            const rrule = event.recurrence[0];
            const rule = rrulestr(rrule);
            return moment(rule.options.until).format("MMM DD, YYYY");
        }
        else{
            return this.formatDate(event.end, 'date');
        }
    },
    syncCourse(){
      const params = { googleCourseId: this.course.googleCourseId}
      return this.$axios.get('/classroom/syncSingleCourse', {params})
        .then( (resp) => {
          const respCourse = resp.data;
          this.$store.dispatch('updateCourse', respCourse);
        })
    }
  }
};
</script>

<style>
</style>